import React from 'react';
import ConfigureGoals from '../components/settings/ConfigureGoals';

export default function GoalsConfig() {
  return <ConfigureGoals />;
}
